export const INVALID_CODENTIFYID = 'INVALID_CODENTIFYID';
export const WRONG_DEVICE = 'WRONG_DEVICE';
export const NOT_FOUND = 'DEVICE_REGISTRATION_FAILED_404_ERROR';
export const ALREADY_OWNED = 'DEVICE_REGISTRATION_FAILED_409_ERROR';
export const ERROR = 'DEVICE_REGISTRATION_FAILED_400_500_ERROR';
